import { render, staticRenderFns } from "./ListaGadget.vue?vue&type=template&id=30b7d27c&scoped=true&"
import script from "./ListaGadget.vue?vue&type=script&lang=js&"
export * from "./ListaGadget.vue?vue&type=script&lang=js&"
import style0 from "./ListaGadget.vue?vue&type=style&index=0&id=30b7d27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7d27c",
  null
  
)

export default component.exports